<template>
  <v-container class="d-flex align-center justify-center" style="height:100%">
    <p
      class="text-center"
      style="max-width:800px"
      :class="$vuetify.breakpoint.smAndDown ? 'text-h6 py-15 px-3' : 'text-h3'"
    >
      Our mission is to advance the world's knowledge to have a positive impact
      on the generations to come
    </p>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      aboutHero:
        "https://pjili-public.s3.ca-central-1.amazonaws.com/global/images/about-hero.jpg"
    };
  },
  computed: {
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? "65vh" : "45vh";
      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    }
  }
};
</script>
